import {User} from '@models/user';
import {ExtraFee} from '@models/extra_fee';
import {Discount} from '@models/discount';
import {SubscriptionType} from '@models/subscriptionType';
import {SubscriptionScenario} from '@models/subscriptionScenario';



export class Subscription {
  id?: number;
  name: string;
  display_name: string;
  attendance_limited: boolean;
  users?: User[];
  extra_fees: ExtraFee[];
  discounts: Discount[];
  'description': string;
  'lockin': boolean;
  'plan_duration_name': string;
  'plan_duration': number;
  'limited': boolean;
  'limited_programs': number;
  'attendance_value': number;
  'auto_renew': number;
  'days_left': number;
  'checkins_left': number;
  'trial_status': boolean;
  'trial_duration': number;
  'trial_duration_name': string;
  'trial_start': string;
  'total_price': number;
  'payment_duration_name': string;
  'payment_price': any;
  'frequency_amount': number;
  'frequency_name': string;
  'discount_status': boolean;
  'discount_value': number;
  'discount_value_mark': string;
  // 'extra_fees_status': boolean;
  // 'extra_fees_name': string;
  // 'extra_fees_price': number;
  // 'extra_fees_condition': string;
  // 'extra_fees_cancelation_status': number;
  // 'extra_fees_cancelation_value': number;
  // 'extra_fees_cancelation_value_name': string;
  // 'extra_fees_onhold_status': number;
  // 'extra_fees_onhold_value': number;
  // 'extra_fees_onhold_maximum_days': number;
  on_hold_fee_value?: any;
  on_hold_percent_value?: number;
  on_hold_duration_name?: string;
  on_hold_duration_value?: number;
  on_hold_status?: boolean;

  program_id?: number;
  program_name?: string;
  active?: number;
  terms_and_conditionals?: string;
  terms_and_conditionals_link?: string;
  trial_max_amount_check_ins?: number;
  approved?: number;
  userSubscriptionId?: number;
  userId?: number;
  scheduledStart?: string;
  renewDate?: string;
  startingDate?: string;
  expireDate?: string;
  trial_start_date?: string;
  trial_end_date?: string;
  classesLeft?: number;
  paymentPriceWithDiscount?: number;
  subscribedStudentsCount?: number;
  lockin_canceling_money_value?: any;
  lockin_canceling_percent_value?: number;
  hold?: number;
  joining_fee?: number;
  is_try_before_you_by?: boolean;
  check_ins_number?: number;
  subscription_type?: SubscriptionType;
  direct_debit?: number;
  membership_builder?: number;
  internal_mail?: number;
  payroll_payments?: number;
  curriculum_builder?: number;
  check_in?: number;
  trial_period?: number;
  currency?: string;
  charged_per?: string;
  billed_to?: string;
  userStatus?: string;
  admin_price?: number;
  scenario?: SubscriptionScenario;
  deleted_at?: string;

  constructor(subscr: Subscription = null) {
    if (subscr) {
      this.id =  subscr.id;
      this.name = subscr.name;
      this.joining_fee = subscr.joining_fee;
      this.display_name = subscr.display_name;
      this.hold = subscr.hold;
      this.attendance_limited = subscr.attendance_limited;
      this.users = subscr.users;
      this.extra_fees = subscr.extra_fees;
      this.discounts = subscr.discounts;
      this.description = subscr.description;
      this.lockin = subscr.lockin;
      this.plan_duration_name = subscr.plan_duration_name;
      this.plan_duration = subscr.plan_duration;
      this.limited = subscr.limited;
      this.limited_programs = subscr.limited_programs;
      this.attendance_value = subscr.attendance_value;
      this.auto_renew = subscr.auto_renew;
      this.days_left = subscr.days_left;
      this.checkins_left = subscr.checkins_left;
      this.check_ins_number = subscr.check_ins_number;
      this.trial_status = subscr.trial_status;
      this.trial_duration = subscr.trial_duration;
      this.trial_duration_name = subscr.trial_duration_name;
      this.trial_start = subscr.trial_start;
      this.total_price = subscr.total_price;
      this.payment_duration_name = subscr.payment_duration_name;
      this.payment_price = subscr.payment_price;
      this.frequency_amount = subscr.frequency_amount;
      this.frequency_name = subscr.frequency_name;
      this.discount_status = subscr.discount_status;
      this.discount_value = subscr.discount_value;
      this.discount_value_mark = subscr.discount_value_mark;
      this.on_hold_fee_value = subscr.on_hold_fee_value;
      this.on_hold_percent_value = subscr.on_hold_percent_value;
      this.on_hold_duration_name = subscr.on_hold_duration_name;
      this.on_hold_duration_value = subscr.on_hold_duration_value;
      this.on_hold_status = subscr.on_hold_status;
      this.program_id = subscr.program_id;
      this.userStatus = subscr.userStatus;
      this.program_name = subscr.program_name;
      this.active = subscr.active;
      this.terms_and_conditionals = subscr.terms_and_conditionals;
      this.terms_and_conditionals_link = subscr.terms_and_conditionals_link;
      this.approved = subscr.approved;
      this.trial_max_amount_check_ins = subscr.trial_max_amount_check_ins;
      this.userSubscriptionId = subscr.userSubscriptionId;
      this.userId = subscr.userId;
      this.scheduledStart = subscr.scheduledStart;
      this.renewDate = subscr.renewDate;
      this.startingDate = subscr.startingDate;
      this.expireDate = subscr.expireDate;
      this.trial_start_date = subscr.trial_start_date;
      this.trial_end_date = subscr.trial_end_date;
      this.classesLeft = subscr.classesLeft;
      this.paymentPriceWithDiscount = subscr.paymentPriceWithDiscount;
      this.subscribedStudentsCount = subscr.subscribedStudentsCount;
      this.lockin_canceling_money_value = subscr.lockin_canceling_money_value;
      this.lockin_canceling_percent_value = subscr.lockin_canceling_percent_value;
      if (subscr.subscription_type) {
        this.subscription_type = new SubscriptionType(subscr.subscription_type);
      }
      this.admin_price = subscr.admin_price;
      this.scenario = subscr.scenario;
      this.deleted_at = subscr.deleted_at;
    }
  }

  static create() {
    return Object.create(this.prototype);
  }

  getOnHoldValue() {
    let price = this.on_hold_fee_value ? parseFloat(this.on_hold_fee_value) : 0;
    if (this.on_hold_percent_value) {
      price += Math.round(parseFloat(this.payment_price) * this.on_hold_percent_value / 100);
    }
    return price;
  }

  isInvisible() {
    return this.subscription_type && this.subscription_type.name && this.subscription_type.name === 'invisible';
  }

  isOnDemandType() {
    return this.subscription_type && this.subscription_type.name && this.subscription_type.name === 'onDemand';
  }
}
